// extracted by mini-css-extract-plugin
export default {"storybrainResets":"_resets_storybrainResets__ahpwl"};